import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import route from "./components/Routes/Routes";
import 'react-toastify/dist/ReactToastify.css';
import BoronDala from './assets/BoronDala_Logo.png'

function App() {
  return (
    <>
      <section className="h-screen bg-black flex justify-center items-center flex-col">
        {/* <RouterProvider router={route}>

        </RouterProvider>
        <ToastContainer /> */}
        <img className="w-[180px] md:w-[250px]" src={BoronDala} alt="BoronDala_Logo" />
        <p className="text-white text-[54px] md:text-[74px]">Coming Soon</p>
      </section>
    </>
  );
}

export default App;
